import React, { useEffect, useState } from "react";
import { EyeOutlined } from "@ant-design/icons";
import { Modal, Typography } from "antd";
import { useAxios } from "../../hooks/useAxios";
import { useNotification } from "../../contexts/NotificationProvider";
import DataTable from "../Common/DataTable";
import ReusableButton from "../FormFields/ReusableButton";
import { useNavigate } from "react-router-dom";

const NewsLetter = () => {
  const [newsletters, setNewsletters] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [viewModalData, setViewModalData] = useState(null);

  const { axiosInstance } = useAxios();
  const notify = useNotification();
  const navigate = useNavigate();

  const fetchNewsletters = async (page = 1) => {
    try {
      const response = await axiosInstance.get(`/api/newsletters/?page=${page}`);
      setNewsletters(response?.data || []);
    } catch (e) {
      notify({
        type: "error",
        message: "Error",
        description: e.message,
      });
    }
  };

  useEffect(() => {
    fetchNewsletters(currentPage);
  }, [currentPage]);

  const columns = [
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      width: 80,
      render: (date) => new Date(date).toLocaleDateString(),
    },
    {
      title: "Description",
      dataIndex: "content",
      key: "preview",
      width: 300,
      render: (html) => {
        const plainText = html?.replace(/<[^>]+>/g, "") || "";
        return plainText.slice(0, 50) + (plainText.length > 50 ? "..." : "");
      },
    },
    {
      title: "Users",
      dataIndex: "user_names",
      key: "user_names",
      width: 250,
      render: (users = []) => (
        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
          {users.slice(0, 3).map((u, i) => (
            <div key={i} style={{
              background: "#f0f0f0",
              borderRadius: "4px",
              padding: "4px 8px",
              fontSize: "12px",
            }}>{u}</div>
          ))}
          {users.length > 3 && (
            <div style={{
              background: "#f0f0f0",
              borderRadius: "4px",
              padding: "4px 8px",
              fontSize: "12px",
              color: "#555",
            }}>
              +{users.length - 3} more
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Actions",
      key: "action",
      width: 80,
      render: (_, row) => (
        <EyeOutlined
          style={{ fontSize: 18, cursor: "pointer", color: "#212180" }}
          onClick={() => setViewModalData(row)}
        />
      ),
    },
  ];

  return (
    <>
      <Modal
        open={!!viewModalData}
        onCancel={() => setViewModalData(null)}
        footer={null}
        width={800}
        title="Newsletter Details"
      >
        {viewModalData && (
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
              {viewModalData.user_names.map((u, i) => (
                <div
                  key={i}
                  style={{
                    background: "#f0f0f0",
                    borderRadius: "4px",
                    padding: "4px 8px",
                    fontSize: "13px",
                  }}
                >
                  {u}
                </div>
              ))}
            </div>
            <div
              style={{
                maxHeight: "200px",
                overflowY: "auto",
                border: "1px solid #ddd",
                borderRadius: "6px",
                padding: "10px",
              }}
              dangerouslySetInnerHTML={{ __html: viewModalData.content }}
            />
          </div>
        )}
      </Modal>

      <div style={{ background: "#ffffff", borderRadius: "6px" }}>
        <div style={{ display: "flex", justifyContent: "flex-end", padding: "10px" }}>
          <ReusableButton
            text="Send Newsletter"
            onClick={() => navigate("/newsletter/send")}
            customStyles={{ width: "max-content" }}
          />
        </div>
        <DataTable
          columns={columns}
          rows={newsletters?.results}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={10}
          totalResults={newsletters?.count || 0}
          showSizeChanger={false}
          selectable={false}
          rowKey="id"
        />
      </div>
    </>
  );
};

export default React.memo(NewsLetter);
